import React, { useState, useEffect } from 'react';
import { Menu, X, Heart, Phone } from 'lucide-react';
import { navLinks } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-[0_2px_20px_rgba(0,0,0,0.05)]' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-20">
        <a href="#" className="flex items-center gap-2 group">
          <img
            src="/assets/acci-logo.png"
            alt="ACCI \u2014 African Caribbean Community Initiative"
            className="h-14 w-auto logo-multiply"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-[13px] font-semibold text-[#0E1112] hover:text-[#6e12ed] transition-colors uppercase tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:01902571230"
            className="flex items-center gap-2 text-sm font-semibold text-[#0E1112] hover:text-[#6e12ed] transition-colors"
          >
            <Phone className="w-4 h-4" />
            01902 571230
          </a>
          <a
            href="#donate"
            className="inline-flex items-center gap-2 bg-[#6e12ed] hover:bg-[#5A0DCC] text-white font-semibold text-sm px-6 h-11 rounded-md transition-colors"
          >
            <Heart className="w-4 h-4 fill-white" />
            Donate
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-[#0E1112]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white">
          <div className="px-5 py-5 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-[#0E1112]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#donate"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#6e12ed] text-white font-semibold px-6 h-12 rounded-md"
            >
              <Heart className="w-4 h-4 fill-white" /> Donate
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
